import { getBackendUrl } from "@Utils";
import { getUrlForImage } from "../cubeComponent/constants/globalFunctions";
import { CONSTANTS } from "../cubeComponent/constants/globalVariable";
import axiosWrapper from "../services/axiosWrapper";
import { setUserDetails } from "../reducers/userDetailsSlice";
import { setCheckIfAuthenticated } from "../reducers/authentication";

const saveUserDetails = setUserDetails;

export function getUserDetails() {
  return (dispatch: any) => {
    axiosWrapper.get(`${getBackendUrl()}/accounts/getUserDetails`).then((response: any) => {
      if (response && response.data.status) {
        const res = response.data.data[0];
        dispatch(
          saveUserDetails({
            ...res,
            lastName: res.lastName ? res.lastName : "",
            profilePicUrl: res.profilePic ? getUrlForImage(res) : "",
            company: {
              ...res.company,
              logoUrl: res.company?.logo ? getUrlForImage(res.company, CONSTANTS.ORGANIZATION) : "",
            },
            // portal: {
            //   ...res.portal,
            //   logoUrl: res?.portal?.logo ? getUrlForImage(res.portal, CONSTANTS.PORTAL) : '',
            // },
            signatureUrl: res.signature
              ? `${getBackendUrl()}/fileSystemServer/getSignDocs/${res.signature}?${Date.now()}`
              : "",
            status: true,
          }),
        );
      } else {
        dispatch(
          saveUserDetails({
            status: false,
          }),
        );
      }
    });
  };
}

export async function initiateSignupEmailVerification(email: string) {
  return await axiosWrapper.post(`${getBackendUrl()}/accounts/initiateSignupEmailVerification`, {
    email,
  });
}

export function getCheckIfAuthenticated() {
  return (dispatch: any) => {
    axiosWrapper
      .get(`${getBackendUrl()}/accounts/checkIfAuthenticated`, {
        withCredentials: true,
      })
      .then((response: any) => {
        dispatch(setCheckIfAuthenticated({ data: response.data }));
        return response.data;
      });
  };
}
